export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// ../~/d3-voronoi/index.js
// module id = J4su
// module chunks = 0